<template>
  <div id="settings">
    <div v-if="!hasAdminAccess" class="bg-gray-100 p-4 rounded-lg ml-10 w-2/3">
      <div class="flex space-x-2">
        <i class="fas fa-exclamation-circle pr-1 text-2xl text-red-500"></i>
        <div class="space-y-2">
          <p class="font-bold text-red-500">
            Display settings are only available to the designated school admin
            user.
          </p>
          <p>
            Please contact your school admin or contact us at PE Passport below:
          </p>
          <ul class="font-bold">
            <li>
              Email:
              <a href="mailto:info@primarypepassport.co.uk"
                >info@primarypepassport.co.uk</a
              >
            </li>
            <li>Telephone: 0800 055 6550</li>
          </ul>
        </div>
      </div>
    </div>

    <div v-else>
      <div
        class="w-2/3 px-4 h-14 mb-1 ml-6 bg-gray-100 flex content-start rounded-lg"
      >
        <button
          v-for="path in tabsList"
          :key="path.id"
          type="button"
          class="header-subnav focus:outline-none"
          @click="showPath(path)"
          v-bind:class="[selectedPath.id === path.id ? 'selected' : '']"
        >
          {{ path.name }}
        </button>
      </div>

      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const noaccess = () => import("@/components/NoAccess.vue");

export default {
  name: "assessmentconfig",
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      access: "currentAccess",
    }),
    tabsList() {
      return this.tabs;
    },
    hasAdminAccess() {
      return this.currentUser.hasAdmin;
    },
  },
  watch: {},
  data() {
    return {
      loading: false,
      hasAccess: false,
      settings: [],
      selectedPath: {},
      tabs: [],
    };
  },
  created() {
    this.loading = true;
    this.hasAccess = this.access.configAccess;
  },
  mounted() {
    this.tabs = [
      { id: 1, name: "Long Term Planning", path: "planning" },
      { id: 2, name: " Year Group Display", path: "yeargroups" },
      { id: 3, name: "Course Fields", path: "fields" },
    ];

    this.selectedPath = this.tabs[0];
  },
  methods: {
    showPath(object) {
      if (this.selectedPath.id === object.id) {
        return;
      }

      this.selectedPath = object;
      this.$router.push("/settings/configuration/" + object.path);
    },
  },
  components: {
    noaccess,
  },
};
</script>


<style scoped>
.header-subnav {
  @apply text-gray-600  mr-1 font-medium;
}

.header-subnav.selected {
  @apply text-gray-800 my-2 font-semibold  bg-white border-none rounded-lg;
}


.selected-row {
  @apply bg-blue-100  !important;
}
</style>

